<template>
  <span>

    <main role="main">
      <article>
      <div class="col-sm-6 col-sm-offset-3">
        <h1>{{content.formData.title}}</h1>
        <div id="errorMessages">
          <ul></ul>
        </div>
        <div id="successMessage">
          
        </div>
      
        <form action="/pub/vu/contacts/processContact.php" method="POST" id="form1">
          <div id="firstName-group" class="form-group">
            <label for="firstName">{{content.formData.labels.firstName}}</label>
            <input type="text" class="form-control" id="firstName" name="firstName"  :placeholder="[[ content.formData.placeholders.firstName ]]" />
          </div>

          <div id="surname-group" class="form-group">
            <label for="surname">{{content.formData.labels.surname}}</label>
            <input type="text" class="form-control" id="surname" name="surname"  :placeholder="[[ content.formData.placeholders.surname ]]" />
          </div>

          <div id="tel-group" class="form-group">
            <label for="telno">{{content.formData.labels.telephone}}</label>
            <input type="text" class="form-control" id="telno" name="telno" :placeholder="[[ content.formData.placeholders.telephone ]]" />
          </div>

          <div id="email-group" class="form-group">
            <label for="email">{{content.formData.labels.email}}</label>
            <input type="text" class="form-control" id="email" name="email" :placeholder="[[ content.formData.placeholders.email ]]" />
          </div>

          <div id="subject-group" class="form-group">
            <label for="subject">{{content.formData.labels.subject}}</label>
            <input type="text" class="form-control" id="subject" name="subject" :placeholder="[[ content.formData.placeholders.subject ]]" />
          </div>
          <div id="enquiry-group" class="form-group">
            <label for="enquiryAlias">{{content.formData.labels.enquiry}}</label>
            <textarea rows="10" cols="50" class="form-control" id="enquiryAlias" name="enquiryAlias"
            :placeholder="[[ content.formData.placeholders.enquiry ]]" ></textarea>
          </div>

          <button type="submit" class="btn btn-success">
            {{content.formData.button.text}}
          </button>
        </form>
      </div>
    </article>

    </main>
  </span>
</template>




<script>
import $ from "jquery";
import Content from "../data/content";



export default {
  name: 'contactus',

  data() {
    return {
      content:Content
    };
  },
  mounted: function () {
    
    $("form").submit(function (event) {
    var formData = {
      firstName: $("#firstName").val(),
      surname: $("#surname").val(),
      email: $("#email").val(),
      telno: $("#telno").val(),
      subject: $("#subject").val(),
      enquiryAlias: $("#enquiryAlias").val(),
    };

    $.ajax({
      type: "POST",
      url: "/pub/vu/contacts/processContact.jsp",
      data: formData,
      dataType: "json",
      encode: true,
    }).done(function (data) {
      /*console.log(data.errors);
      console.log(data.successMessages);*/
      $("input, textarea").removeClass("error")
      $('#errorMessages ul li').remove();
      

      $.each(data.errors, function(key, value) {      
        $('#errorMessages ul').append("<li>"+value+"</li>");     
      });    
      $.each(data.errors, function(key) {
        $('[name="'+key+'"]').addClass("error");   
      });
    

      
      if (data.success){

        $.each(data.successMessages, function(key, value) { 
          $('#successMessage').empty();
          $('#successMessage').hide();
          $('#successMessage').append(value);     
          $('#successMessage').show( "slow", function() {
             // Animation complete.
          });    
          $('#form1').hide();

        });   
        
      }

    });

    event.preventDefault();
  });
  }
}
</script>

<style>
.error {
  border-color:red;
}
main article{
    padding: 145px 2%;
    .col-sm-6{
      margin: auto;
      .form-group{
        margin: 10px 0;
      }
    }
    h1, #successMessage{
      text-align: center;
    }
}
button{
  width: 100%;
  margin: 10px 0;
}
#errorMessages ul {
 color: red;
 padding: 0px 20px ;
}

</style>
